import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDiasFechaInicioObra,
  getTiposContratista,
  postIdentificacionForm
} from "../../../../redux/actions/obra";
import CircularLoading from "../../../commons/loading/CircularLoading";
import IdentificacionForm from "./IdentificacionForm";

const initialValues = {
  denominacionObra: "",
  numeroObraSRT: null,
  fechaInicioObra: null,
  fechaFinObra: null,
  idDependenciaEmpleador: null,
  resolucion: "",
  idTipoContratista: '',
  superficieAConstruir: "",
  numeroPlantas: "",
  observaciones: "",
  idTipoAvisoObra: null,
  fechaHastaExtensionObra: null,
  fechaSuspension: null,
  fechaFinSuspencion: null,
  fechaReinicioSuspension: null,
  fechaFinReinicioSuspension: null,
  fechaRecepcion: null,
};

const IdentificacionContainer = ({ nextForm, lastFormProps, handleCancel }) => {
  const dispatch = useDispatch();

  const tiposContratista = useSelector((state) => state.obra.tipoContratista);
  const identificacion = useSelector(
    (state) => state.obra.postNuevaObra.identificacion
  );



  const [formModel, setFormModel] = useState();

  useEffect(() => {
    if (tiposContratista.data.length === 0) {
      dispatch(getTiposContratista());
    }
    dispatch(getDiasFechaInicioObra());
  }, []);

  useEffect(() => {
    if (Object.keys(identificacion).length > 0) {
      setFormModel({ ...initialValues, ...identificacion });
    } else {
      setFormModel(initialValues);
    }
  }, [identificacion]);

  const handleSubmit = (values) => {
    dispatch(postIdentificacionForm(values));
    nextForm("Ubicación");

  };

  if (!formModel) {
    return <CircularLoading />;
  }
  return (
    <IdentificacionForm
      formModel={formModel}
      handleSubmit={handleSubmit}
      setFormModel={setFormModel}
      initialValues={initialValues}
      lastFormProps={lastFormProps}
      handleCancel={lastFormProps?.idGestionObra ? handleCancel : null}
    />
  );
};

export default IdentificacionContainer;
